module.exports = __webpack_public_path__ + "resource/img/edit.0d384d65.svg";